import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { section2Validation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import {
  addSection2Data,
  deleteSection,
  section2ListingData,
} from "../../../redux/cms/action";
import logoimage from "../../assets/images/logoimage.png";
import { CardBody, Modal } from "reactstrap";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import DeleteSection2 from "./DelectSection2";
import { getOssClient } from "../../Common/Utils/ossUtils";

const Section2Add = () => {
  const [params, setParams] = useState({
    section: 2,
    page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [section2Image, Setsection1Image] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const section2Data = useSelector(
    (state) => state?.reusableSlice?.getSection2listing
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [imageLoading, setImageLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      icon: "",
      section: 2,
      position: "",
    },
    validationSchema: section2Validation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
      };
      dispatch(addSection2Data(data, setLoading, navigate));
      formik.resetForm();
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };

  const handleLogoChange = async (event) => {
    const file = event.currentTarget.files[0];

    if (!file) return;
    try {
      const ossClient = await getOssClient();

      const fileName = `images/${Date.now()}_${file.name}`;

      const result = await ossClient.put(fileName, file, {
        progress: (p) => {
          setUploadProgress(Math.round(p * 100));
        },
        mimeType: file.type,
      });
      formik.setFieldValue("icon", result.url);
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const handleChangePosition = (e) => {
    const pos = e.target.value;
    formik.setFieldValue("position", Number(pos));
  };
  useEffect(() => {
    dispatch(section2ListingData(params));
  }, [dispatch, params]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteSection(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <h3>Brand</h3>

        <div>
          <form onSubmit={formik.handleSubmit}>
            <div className=" ">
              <div className="row ">
                <div className="business-logo d-flex align-items-center col-md-12 form-group justify-content-center flex-column">
                  <div className="profile-edit">
                    {imageLoading ? (
                      <div className="loader-container">
                        <i className="fa fa-spinner fa-spin loader-icon"></i>{" "}
                      </div>
                    ) : (
                      <img
                        src={formik.values.icon || logoimage}
                        alt="Business Logo"
                        style={{ backgroundColor: "green" }}
                      />
                    )}
                    <div>
                      <label
                        htmlFor="logo-upload"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-pencil"></i>
                      </label>
                      <p>Add Image</p>
                    </div>
                  </div>
                  <div className="text-center">
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="logo-upload"
                      onChange={handleLogoChange}
                    />
                  </div>
                  {formik.touched.icon && formik.errors.icon ? (
                    <div className="error">{formik.errors.icon}</div>
                  ) : null}
                </div>
                <div className="d-flex justify-content-between align-items-center col-md-12">
                  <div className="form-group col-md-4">
                    <label htmlFor="status">Position</label>
                    <select
                      id="position"
                      title="position"
                      className="form-control"
                      onChange={handleChangePosition}
                      onBlur={formik.handleBlur}
                      value={formik.values.position}
                    >
                      <option value="">Select Position</option>
                      {Array.from({ length: 50 }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
                    </select>
                    {formik.touched.position && formik.errors.position ? (
                      <div className="error">{formik.errors.position}</div>
                    ) : null}
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-end  "
                    style={{ columnGap: "20px" }}
                  >
                    <button
                      className="submit-btn   "
                      style={{ width: "max-content" }}
                      type="submit"
                    >
                      {!loading ? "Submit" : <Spinner />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <CardBody className="table-sec px-3">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Position</th>
                  <th scope="col">Icon</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {section2Data?.cms?.length > 0 ? (
                  section2Data?.cms?.map((item, index) => (
                    <tr key={index}>
                      <td> {index + 1 + (params?.page - 1) * 10}</td>
                      <td>{item?.position} </td>

                      <td>
                        <img
                          src={item?.icon}
                          className="img_styles"
                          style={{ backgroundColor: "green" }}
                        ></img>
                      </td>
                      <td>
                        <div
                        // className="d-flex align-items-center justify-content-center"
                        // style={{ columnGap: "10px" }}
                        >
                          <button
                            className="background-button"
                            onClick={() => {
                              setModal(true);
                              setCurrentComponent(item);
                            }}
                          >
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <CommonPagination
              params={params}
              setParams={setParams}
              pagination_meta={section2Data?.pagination_meta}
            />
          </CardBody>
          <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
            <DeleteSection2
              modalTitle={"cms"}
              setModal={setModal}
              currentComponent={currentComponent}
              deleteComponent={deleteComponent}
            ></DeleteSection2>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Section2Add;
